import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

export function SignupPage() {
  return (
    <div className="min-h-screen bg-surface-dim flex items-center justify-center p-6 transition-colors duration-500">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <Link to="/" className="inline-block mb-4">
             <span className="font-label-caps text-[14px] text-primary uppercase tracking-[0.3em] font-bold">DocForge</span>
          </Link>
          <h1 className="font-h1 text-h1 text-on-surface mb-2">Join the Guild</h1>
          <p className="font-body-md text-body-md text-on-surface-variant italic">Create your credentials to begin your editorial journey.</p>
        </div>

        <div className="bg-surface border border-outline-variant rounded-2xl p-8 md:p-10 shadow-2xl ink-drop-shadow relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1 bg-primary/20"></div>
          
          <form className="space-y-5">
            <div className="space-y-2">
              <label className="font-label-caps text-[10px] text-on-surface-variant uppercase tracking-widest block" htmlFor="name">
                Full Name
              </label>
              <input 
                type="text" 
                id="name" 
                placeholder="Marcus Thorne"
                className="w-full bg-surface-container-low border border-outline-variant rounded-lg px-4 py-3 font-body-md text-on-surface focus:outline-none focus:ring-1 focus:ring-primary transition-all"
              />
            </div>

            <div className="space-y-2">
              <label className="font-label-caps text-[10px] text-on-surface-variant uppercase tracking-widest block" htmlFor="email">
                Email Address
              </label>
              <input 
                type="email" 
                id="email" 
                placeholder="scribe@docforge.ai"
                className="w-full bg-surface-container-low border border-outline-variant rounded-lg px-4 py-3 font-body-md text-on-surface focus:outline-none focus:ring-1 focus:ring-primary transition-all"
              />
            </div>

            <div className="space-y-2">
              <label className="font-label-caps text-[10px] text-on-surface-variant uppercase tracking-widest block" htmlFor="password">
                Password
              </label>
              <input 
                type="password" 
                id="password" 
                placeholder="••••••••"
                className="w-full bg-surface-container-low border border-outline-variant rounded-lg px-4 py-3 font-body-md text-on-surface focus:outline-none focus:ring-1 focus:ring-primary transition-all"
              />
            </div>

            <div className="pt-2">
               <p className="text-[10px] text-on-surface-variant leading-relaxed mb-6 font-body-md">
                 By creating an account, you agree to follow the <Link to="/terms" className="text-primary hover:underline">Guild Regulations</Link> and the <Link to="/privacy" className="text-primary hover:underline">Code of Privacy</Link>.
               </p>
               <button className="w-full bg-primary text-on-primary py-4 rounded-lg font-label-caps text-label-caps uppercase tracking-widest shadow-lg hover:shadow-primary/20 transition-all active:translate-y-px">
                 Register New Account
               </button>
            </div>
          </form>

          <div className="mt-8 pt-8 border-t border-outline-variant/30 text-center">
            <span className="font-label-caps text-[10px] text-on-surface-variant uppercase tracking-widest block mb-4">Or sign up with</span>
            <div className="grid grid-cols-2 gap-4">
               <button className="flex items-center justify-center gap-3 bg-surface border border-outline-variant py-3 rounded-lg hover:bg-surface-container-high transition-colors">
                  <img src="https://www.google.com/favicon.ico" className="w-4 h-4 grayscale group-hover:grayscale-0" alt="Google" />
                  <span className="font-label-caps text-[10px] uppercase tracking-widest">Google</span>
               </button>
               <button className="flex items-center justify-center gap-3 bg-surface border border-outline-variant py-3 rounded-lg hover:bg-surface-container-high transition-colors">
                  <span className="material-symbols-outlined text-[18px]">terminal</span>
                  <span className="font-label-caps text-[10px] uppercase tracking-widest">GitHub</span>
               </button>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="font-body-md text-on-surface-variant text-sm">
            Already a member? <Link to="/login" className="text-primary font-bold hover:underline">Sign In Instead</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
